import React from 'react';
import type { RawData } from '../../../types';
import { Radio } from '@beeline.com/bp-design-system';
import { type Column, type FormatterProps, useRowSelection } from '../../../ReactDataGrid';
const SELECT_COLUMN_KEY = 'select-row';

function SelectFormatter(props: FormatterProps<unknown>): any {
  const [isRowSelected, onRowSelectionChange] = useRowSelection();

  return (
    <div>
      <Radio
        aria-label="Select"
        checked={isRowSelected}
        style={{ padding: 0, marginTop: -2, marginLeft: -2 }}
        onChange={(event) => {
          onRowSelectionChange({
            row: props.row,
            checked: Boolean(event.target.checked),
            isShiftClick: (event.nativeEvent as MouseEvent).shiftKey
          });
        }}
      />
    </div>
  );
}

export const SelectColumn: Column<any, any> = {
  key: SELECT_COLUMN_KEY,
  name: '',
  width: 45,
  minWidth: 45,
  maxWidth: 45,
  resizable: false,
  sortable: false,
  frozen: true,
  cellClass: 'rdg-radio',
  formatter: SelectFormatter
};

export const generateSelectionColumns = (data: RawData[]) => {
  const longestRowLength = data.reduce((acc, curr) => (acc > curr.length ? acc : curr.length), 0);
  return [
    SelectColumn,
    ...Array.from(Array(longestRowLength), (_, index) => ({
      key: index.toString(),
      name: ''
    }))
  ];
};
